
        <div class="space-y-8 pb-12">
            <div class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                <div>
                    <h1 class="text-4xl font-bold tracking-tight">Phases Management</h1>
                    <p class="mt-2 text-lg text-[color:var(--muted-foreground)]">Manage project phases</p>
                </div>
                <button
                    type="button"
                    (click)="openCreate()"
                    class="inline-flex items-center gap-2 rounded-xl bg-[color:var(--primary)] px-4 py-2 font-semibold text-[color:var(--primary-foreground)] shadow-sm transition-colors hover:bg-[color:var(--primary-hover)]"
                >
                    <lucide-icon name="plus" class="h-5 w-5"></lucide-icon>
                    Create Phase
                </button>
            </div>

            <div class="rounded-2xl border border-[color:var(--border)] bg-[color:var(--card)] shadow-sm">
                <div class="border-b border-[color:var(--border)] px-6 py-4">
                    <p class="font-semibold text-[color:var(--foreground)]">Select Project</p>
                    <p class="text-sm text-[color:var(--text-subtle)]">Choose a project to view its phases</p>
                </div>
                <div class="p-6">
                    <ng-container *ngIf="!loadingProjects; else loadingProjectsTpl">
                        <select
                            [(ngModel)]="selectedProjectId"
                            (ngModelChange)="loadPhases()"
                            class="w-full rounded-xl border border-[color:var(--input)] bg-[color:var(--card)] px-3 py-2 text-[color:var(--foreground)] focus:border-[color:var(--ring)] focus:outline-none"
                        >
                            <option value="" disabled>Select a project</option>
                            <option *ngFor="let project of projects" [value]="project.id">{{ project.name }}</option>
                        </select>
                    </ng-container>

                    <ng-template #loadingProjectsTpl>
                        <div class="flex items-center gap-3 text-[color:var(--text-subtle)]">
                            <lucide-icon name="loader-2" class="h-4 w-4 animate-spin"></lucide-icon>
                            Loading projects...
                        </div>
                    </ng-template>
                </div>
            </div>

            <ng-container *ngIf="selectedProjectId">
                <div class="rounded-2xl border border-[color:var(--border)] bg-[color:var(--card)] shadow-sm">
                    <div class="flex items-center justify-between border-b border-[color:var(--border)] px-6 py-4">
                        <div>
                            <p class="font-semibold text-[color:var(--foreground)]">Phases</p>
                            <p class="text-sm text-[color:var(--text-subtle)]">
                                {{ phases.length }} {{ phases.length === 1 ? 'phase' : 'phases' }} in this project
                            </p>
                        </div>
                    </div>
                    <div class="p-6">
                        <ng-container *ngIf="!loadingPhases; else loadingPhasesTpl">
                            <div *ngIf="phases.length > 0; else emptyPhases" class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
	                                <div
	                                    *ngFor="let phase of phases"
	                                    class="rounded-2xl border border-[color:var(--border)] bg-[color:var(--muted)] p-4 transition-colors hover:bg-[color:var(--hover)]"
	                                >
	                                    <div class="flex items-start justify-between gap-3">
	                                        <div class="min-w-0">
	                                            <div class="flex items-center gap-2">
	                                                <lucide-icon name="layers" class="h-5 w-5 text-[color:var(--primary)]"></lucide-icon>
	                                                <h3 class="truncate text-base font-semibold text-[color:var(--foreground)]">{{ phase.name }}</h3>
	                                            </div>
	                                            <div class="mt-2 space-y-1 text-xs text-[color:var(--text-subtle)]">
	                                                <p *ngIf="phase.deliveryDate">Delivery: {{ phase.deliveryDate | date:'MMM y' }}</p>
	                                                <p *ngIf="phase.status">Status: {{ phase.status }}</p>
	                                            </div>
	                                        </div>
	                                        <div class="flex gap-2">
	                                            <button
	                                                type="button"
	                                                (click)="openEdit(phase)"
                                                class="inline-flex items-center gap-2 rounded-xl border border-[color:var(--border)] bg-[color:var(--card)] px-3 py-1.5 text-xs font-semibold text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)]"
                                            >
                                                <lucide-icon name="edit-2" class="h-4 w-4"></lucide-icon>
                                                Edit
                                            </button>
                                            <button
                                                type="button"
                                                (click)="openOfferImages(phase)"
                                                class="inline-flex items-center gap-2 rounded-xl border border-[color:var(--border)] bg-[color:var(--card)] px-3 py-1.5 text-xs font-semibold text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)]"
                                            >
                                                <lucide-icon name="image" class="h-4 w-4"></lucide-icon>
                                                Offer images
                                            </button>
                                            <button
                                                type="button"
                                                (click)="openDelete(phase)"
                                                class="inline-flex items-center gap-2 rounded-xl border border-red-300 bg-transparent px-3 py-1.5 text-xs font-semibold text-red-600 transition hover:bg-red-50"
                                            >
                                                <lucide-icon name="trash-2" class="h-4 w-4"></lucide-icon>
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-template #loadingPhasesTpl>
                            <div class="flex items-center gap-3 text-[color:var(--text-subtle)]">
                                <lucide-icon name="loader-2" class="h-4 w-4 animate-spin"></lucide-icon>
                                Loading phases...
                            </div>
                        </ng-template>
                    </div>
                </div>
            </ng-container>

            <ng-template #emptyPhases>
                <div class="rounded-2xl border border-[color:var(--border)] bg-[color:var(--muted)] p-10 text-center">
                    <div class="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-[color:var(--secondary)] border border-[color:var(--border)]">
                        <lucide-icon name="layers" class="h-6 w-6 text-[color:var(--primary)]"></lucide-icon>
                    </div>
                    <h3 class="text-lg font-semibold text-[color:var(--foreground)]">No Phases Yet</h3>
                    <p class="mt-1 text-sm text-[color:var(--text-subtle)]">This project doesn't have any phases yet.</p>
                    <button
                        type="button"
                        (click)="openCreate()"
                        class="mt-5 inline-flex items-center gap-2 rounded-xl bg-[color:var(--primary)] px-4 py-2 font-semibold text-[color:var(--primary-foreground)] shadow-sm transition-colors hover:bg-[color:var(--primary-hover)]"
                    >
                        <lucide-icon name="plus" class="h-5 w-5"></lucide-icon>
                        Create First Phase
                    </button>
                </div>
            </ng-template>

            <div *ngIf="showDialog" class="fixed inset-0 z-40 flex items-start justify-center bg-black/50 px-4 py-8 overflow-y-auto">
                <div class="w-full max-w-md rounded-3xl border border-[color:var(--border)] bg-[color:var(--popover)] p-6 shadow-2xl max-h-[90vh] overflow-y-auto">
                    <div class="flex items-start justify-between gap-4">
                        <div>
                            <p class="text-xs font-semibold uppercase tracking-[0.18em] text-[color:var(--text-subtle)]">
                                {{ dialogMode === 'create' ? 'Create Phase' : 'Edit Phase' }}
                            </p>
                            <h3 class="mt-1 text-xl font-semibold text-[color:var(--foreground)]">
                                {{ dialogMode === 'create' ? 'Add new phase' : 'Update phase name' }}
                            </h3>
                        </div>
                        <button type="button" (click)="closeDialog()" class="rounded-full border border-[color:var(--border)] p-2 text-[color:var(--text-subtle)] hover:bg-[color:var(--hover)]">
                            <lucide-icon name="x" class="h-4 w-4"></lucide-icon>
                        </button>
                    </div>

	                    <div class="mt-6 space-y-4">
	                        <div class="space-y-2">
	                            <label class="text-sm font-semibold text-[color:var(--foreground)]">Phase Name</label>
	                            <input
	                                [(ngModel)]="dialogName"
	                                type="text"
	                                class="w-full rounded-xl border border-[color:var(--input)] bg-[color:var(--card)] px-3 py-2 text-[color:var(--foreground)] placeholder:text-[color:var(--text-subtle)] focus:border-[color:var(--ring)] focus:outline-none"
	                                placeholder="Phase 1 - Foundation"
	                            />
	                        </div>
	                        <div class="grid gap-4 sm:grid-cols-2">
	                            <div class="space-y-2">
	                                <label class="text-sm font-semibold text-[color:var(--foreground)]">Status</label>
	                                <select
	                                    [(ngModel)]="dialogStatus"
	                                    class="w-full rounded-xl border border-[color:var(--input)] bg-[color:var(--card)] px-3 py-2 text-[color:var(--foreground)] focus:border-[color:var(--ring)] focus:outline-none"
	                                >
	                                    <option *ngIf="dialogStatus && dialogStatus !== 'Active' && dialogStatus !== 'Delivered'" [value]="dialogStatus">{{ dialogStatus }}</option>
	                                    <option value="Active">Active</option>
	                                    <option value="Delivered">Delivered</option>
	                                </select>
	                            </div>
	                            <div class="space-y-2">
	                                <label class="text-sm font-semibold text-[color:var(--foreground)]">Delivery Date</label>
	                                <input
	                                    [(ngModel)]="dialogDeliveryDate"
	                                    type="date"
	                                    class="w-full rounded-xl border border-[color:var(--input)] bg-[color:var(--card)] px-3 py-2 text-[color:var(--foreground)] focus:border-[color:var(--ring)] focus:outline-none"
	                                />
	                            </div>
	                        </div>
	                        <div class="space-y-2" *ngIf="dialogMode === 'create'">
	                            <label class="text-sm font-semibold text-[color:var(--foreground)]">Project</label>
	                            <select
	                                [(ngModel)]="dialogProjectId"
                                class="w-full rounded-xl border border-[color:var(--input)] bg-[color:var(--card)] px-3 py-2 text-[color:var(--foreground)] focus:border-[color:var(--ring)] focus:outline-none"
                            >
                                <option value="" disabled>Select a project</option>
                                <option *ngFor="let project of projects" [value]="project.id">{{ project.name }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="mt-6 flex items-center justify-end gap-3">
                        <button type="button" (click)="closeDialog()" class="rounded-xl border border-[color:var(--border)] bg-[color:var(--card)] px-4 py-2 font-semibold text-[color:var(--foreground)] hover:bg-[color:var(--hover)]">
                            Cancel
                        </button>
                        <button
                            type="button"
                            (click)="saveDialog()"
                            [disabled]="dialogSaving"
	                            class="inline-flex items-center gap-2 rounded-xl bg-[color:var(--primary)] px-4 py-2 font-semibold text-[color:var(--primary-foreground)] shadow-sm transition-colors hover:bg-[color:var(--primary-hover)] disabled:opacity-60"
	                        >
                            <lucide-icon *ngIf="dialogSaving" name="loader-2" class="h-4 w-4 animate-spin"></lucide-icon>
                            <span>{{ dialogSaving ? 'Saving...' : 'Save' }}</span>
                        </button>
                    </div>
                </div>
            </div>

            <div *ngIf="showOfferImagesDialog" class="fixed inset-0 z-40 flex items-start justify-center bg-black/50 px-4 py-8 overflow-y-auto">
                <div class="w-full max-w-3xl rounded-3xl border border-[color:var(--border)] bg-[color:var(--popover)] p-6 shadow-2xl space-y-4 max-h-[85vh] overflow-y-auto">
                    <div class="flex items-start justify-between gap-4">
                        <div class="min-w-0">
                            <p class="text-xs font-semibold uppercase tracking-[0.18em] text-[color:var(--text-subtle)]">Offer images</p>
                            <h3 class="mt-1 truncate text-xl font-semibold text-[color:var(--foreground)]">
                                {{ offerImagesPhase?.name || 'Phase' }}
                            </h3>
                            <p class="mt-1 text-sm text-[color:var(--muted-foreground)]">
                                These images are used on offer PDFs (required before sending offers).
                            </p>
                        </div>
                        <button type="button" (click)="closeOfferImages()" class="rounded-full border border-[color:var(--border)] p-2 text-[color:var(--text-subtle)] hover:bg-[color:var(--hover)]">
                            <lucide-icon name="x" class="h-4 w-4"></lucide-icon>
                        </button>
                    </div>

                    <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                        <div class="flex flex-wrap items-center gap-2">
                            <label class="inline-flex cursor-pointer items-center gap-2 rounded-xl bg-[color:var(--primary)] px-4 py-2 font-semibold text-[color:var(--primary-foreground)] shadow-sm transition-colors hover:bg-[color:var(--primary-hover)] disabled:opacity-60">
                                <lucide-icon [name]="offerImagesUploading ? 'loader-2' : 'upload'" class="h-4 w-4" [class.animate-spin]="offerImagesUploading"></lucide-icon>
                                <span>{{ offerImagesUploading ? 'Uploading…' : 'Upload images' }}</span>
                                <input type="file" class="hidden" multiple accept="image/*" (change)="onOfferImagesSelected($event)" [disabled]="offerImagesUploading" />
                            </label>
                        </div>
                        <button type="button" (click)="refreshOfferImages()" [disabled]="offerImagesLoading" class="inline-flex items-center gap-2 rounded-xl border border-[color:var(--border)] bg-[color:var(--card)] px-4 py-2 font-semibold text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)] disabled:opacity-60">
                            <lucide-icon [name]="offerImagesLoading ? 'loader-2' : 'refresh-ccw'" class="h-4 w-4" [class.animate-spin]="offerImagesLoading"></lucide-icon>
                            Refresh
                        </button>
                    </div>

                    <p *ngIf="offerImagesError" class="text-sm text-red-600">{{ offerImagesError }}</p>

                    <div *ngIf="offerImagesLoading" class="flex items-center gap-3 text-[color:var(--text-subtle)]">
                        <lucide-icon name="loader-2" class="h-4 w-4 animate-spin"></lucide-icon>
                        Loading images…
                    </div>

                    <div *ngIf="!offerImagesLoading && offerImages.length === 0" class="rounded-2xl border border-dashed border-[color:var(--border)] bg-[color:var(--muted)] p-10 text-center text-sm text-[color:var(--muted-foreground)]">
                        No offer images yet.
                    </div>

                    <div *ngIf="!offerImagesLoading && offerImages.length" class="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
                        <div *ngFor="let img of offerImages; let i = index" class="rounded-2xl border border-[color:var(--border)] bg-[color:var(--card)] p-3 shadow-sm">
                            <div class="aspect-[4/3] overflow-hidden rounded-xl border border-[color:var(--border)] bg-[color:var(--muted)]">
                                <img [src]="img.url" alt="Offer image" class="h-full w-full object-cover" loading="lazy" decoding="async" />
                            </div>
                            <div class="mt-3 flex items-center justify-between gap-2">
                                <div class="flex items-center gap-2">
                                    <button type="button" (click)="moveOfferImage(i, -1)" [disabled]="i === 0 || offerImagesSavingOrder" class="h-9 w-9 rounded-xl border border-[color:var(--border)] text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)] disabled:opacity-40">
                                        <lucide-icon name="chevron-up" class="h-4 w-4 mx-auto"></lucide-icon>
                                    </button>
                                    <button type="button" (click)="moveOfferImage(i, 1)" [disabled]="i === offerImages.length - 1 || offerImagesSavingOrder" class="h-9 w-9 rounded-xl border border-[color:var(--border)] text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)] disabled:opacity-40">
                                        <lucide-icon name="chevron-down" class="h-4 w-4 mx-auto"></lucide-icon>
                                    </button>
                                </div>
                                <button type="button" (click)="deleteOfferImage(img)" [disabled]="offerImagesUploading || offerImagesSavingOrder" class="inline-flex items-center gap-2 rounded-xl border border-red-500/30 bg-red-500/10 px-3 py-2 text-xs font-semibold text-red-700 transition hover:bg-red-500/20 disabled:opacity-50">
                                    <lucide-icon name="trash-2" class="h-4 w-4"></lucide-icon>
                                    Remove
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="showDeleteDialog" class="fixed inset-0 z-40 flex items-start justify-center bg-black/50 px-4 py-8 overflow-y-auto">
                <div class="w-full max-w-sm rounded-3xl border border-[color:var(--border)] bg-[color:var(--popover)] p-6 shadow-2xl space-y-4 max-h-[80vh] overflow-y-auto">
                    <div class="flex items-start justify-between gap-4">
                        <div>
                            <p class="text-xs font-semibold uppercase tracking-[0.18em] text-[color:var(--text-subtle)]">Delete Phase</p>
                            <h3 class="mt-1 text-xl font-semibold text-[color:var(--foreground)]">Are you sure?</h3>
                        </div>
                        <button type="button" (click)="closeDeleteDialog()" class="rounded-full border border-[color:var(--border)] p-2 text-[color:var(--text-subtle)] hover:bg-[color:var(--hover)]">
                            <lucide-icon name="x" class="h-4 w-4"></lucide-icon>
                        </button>
                    </div>
                    <p class="text-sm text-[color:var(--muted-foreground)]">This action cannot be undone.</p>
                    <div class="flex items-center justify-end gap-3">
                        <button type="button" (click)="closeDeleteDialog()" class="rounded-xl border border-[color:var(--border)] bg-[color:var(--card)] px-4 py-2 font-semibold text-[color:var(--foreground)] hover:bg-[color:var(--hover)]">
                            Cancel
                        </button>
                        <button
                            type="button"
                            (click)="confirmDelete()"
                            [disabled]="dialogSaving"
                            class="inline-flex items-center gap-2 rounded-xl bg-red-600 px-4 py-2 font-semibold text-white transition hover:bg-red-500 disabled:opacity-60"
                        >
                            <lucide-icon *ngIf="dialogSaving" name="loader-2" class="h-4 w-4 animate-spin"></lucide-icon>
                            <span>{{ dialogSaving ? 'Deleting...' : 'Delete' }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    
